import { useContext } from 'react';
import { AuthContext, AuthContextProps } from './AuthContext';

export function useAuthContext(): AuthContextProps {
  return useContext<AuthContextProps>(AuthContext);
}
